import styled from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'
import SearchIcon from '../../../images/icon_search_white.svg'
import GrayTimesIcon from '../../../images/icon_times_dark_gray.svg'
import WhiteTimesIcon from '../../../images/icon_times_white.svg'
import { brandConfig } from '../../../config/brandConfig'

export const StyledOuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  box-sizing: border-box;

  height: calc(100vh - var(--header-size));
  width: 100%;
  z-index: 10;
  background-color: ${themeStyles.colors.black.main};

  > div {
    overflow-y: auto;
  }

  ${themeMedia.maxTablet`
    z-index: 500;
    top: 0;
    height: 100vh;
  `}
`

export const StyledModalNavBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${themeStyles.colors.white.main};
  height: 3em;
`

export const StyledBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1em;
  margin: 0.5em 0 1em;

  ${themeMedia.tablet`
    margin: 2em 0 3em;
  `}

  ${themeMedia.uhd`
    margin: 3em 0 4em;
  `}
`

const iconOffset = '12px'

export const StyledInputWrapper = styled.div`
  position: relative;
  width: 100%;

  ${themeMedia.tablet`
    width: 600px;
  `};

  input {
    font-family: ${brandConfig.fonts.text.input.family};
    width: 100%;

    height: 40px;
    border-radius: 20px;
    border: 0;
    outline: none;
    padding: 0 32px;
    box-sizing: border-box;
    letter-spacing: -0.14px;
    text-align: center;
    color: ${themeStyles.colors.white.main};

    background: ${themeStyles.colors.darkGreys[5].main} url(${SearchIcon})
      ${iconOffset} no-repeat;
    background-size: 24px;
  }

  button {
    position: absolute;
    top: 50%;
    right: ${iconOffset};
    transform: translateY(-50%);
  }
`

export const StyledClearButton = styled.button`
  display: block;
  padding: 0;
  background-color: ${themeStyles.colors.darkGreys[3].main};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 100%;
  width: 1em;
  height: 1em;
  background-image: url(${GrayTimesIcon});
  background-size: 0.5em;
`

const closeButtonSize = '1.2em'

export const StyledCloseButton = styled.button`
  display: block;
  padding: 0;
  background-color: transparent;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: ${closeButtonSize};
  height: ${closeButtonSize};
  background-image: url(${WhiteTimesIcon});
`

export const StyledEmptyOffsetDiv = styled.div`
  height: ${closeButtonSize};
  width: ${closeButtonSize};
  background: transparent;
`
